import { Input, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

export const useStyles = makeStyles<Theme>((theme) => ({
  inputText: () => ({
    width: '100%',
    borderRadius: '10px',
    overflow: 'hidden',

    '& .MuiFilledInput-root': {
      background: '#fff',
      borderRadius: 'inherit',
      overflow: 'hidden',
      color: '#000'
    },
    '& .MuiFormHelperText-root': {
      background: 'none !important',
    },
    '& .MuiFormHelperText-root.Mui-disabled': {
      color: theme.palette.error.main,
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none'
    },

    '& .MuiFilledInput-underline:after': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiFilledInput-underline.Mui-error:after': {
      borderColor: '#f44336'
    },
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main
    },
    '& .MuiFormLabel-asterisk': {
      color: 'red'
    },
    '& .Mui-disabled': {
      backgroundColor: '#d7d7d7',
      color: 'rgba(0, 0, 0, 0.38)'
    }
  }),
  inputTextSecondary: () => ({
    width: '100%',
    borderRadius: '4px',

    '& .MuiOutlinedInput-root': {
      background: '#fff',
      borderRadius: 'inherit'
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiOutlinedInput-notchedOutline.Mui-error': {
      borderColor: '#f44336'
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main
    },
    '& .MuiFormLabel-asterisk': {
      color: 'red'
    },
    '& .Mui-disabled': {
      backgroundColor: '#d7d7d7',
      color: 'rgba(0, 0, 0, 0.38)'
    },
    '& .MuiFormHelperText-root.Mui-disabled': {
      color: theme.palette.error.main,
      background: 'none'
    }
  }),
  inputTextUnderline: () => ({
    width: '100%',
    borderRadius: '10px',
    overflow: 'hidden',

    '& .MuiFilledInput-root': {
      background: '#fff',
      borderRadius: 'inherit',
      overflow: 'hidden',
      color: '#000'
    },

    '& .MuiFilledInput-underline:after': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiFilledInput-underline.Mui-error:after': {
      borderColor: '#f44336'
    },
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main
    },
    '& .MuiFormLabel-asterisk': {
      color: 'red'
    },
    '& .Mui-disabled': {
      backgroundColor: '#d7d7d7',
      color: 'rgba(0, 0, 0, 0.38)'
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: '1px solid #0000006b !important'
    },
    '& .MuiInputBase-root': {
      background: 'none'
    },
    '& .MuiFilledInput-inputMarginDense': {
      paddingTop: '20px'
    }
  })
}));

export const InputTextOutlined = styled(Input)`
  &&& {
    height: 40px;
    background: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.grayDark};
    border-radius: 10px;
    overflow: hidden;
    text-align: center;

    &.MuiInput-underline:before {
      border-bottom: none;
    }

    &.MuiInput-underline:hover:before {
      border-bottom: none !important;
    }
    &.Mui-disabled {
      background-color: #d7d7d7;
      color: rgba(0, 0, 0, 0.38);
    }
    &.Mui-error {
      border-color: #f44336;
    }
    .MuiInputBase-input {
      font: inherit;
      font-size: 0.875rem;
      letter-spacing: normal;
      height: 100%;
      color: #000;
      padding-left: 8px;
      padding-right: 8px;


      &.Mui-disabled {
        color: rgba(0, 0, 0, 0.38);
      }

      /* style placeholder */
      &::placeholder {
        color: #000;
      }
    }
  }
`;

